<script setup lang="ts">
// Product of Launch Maniac LLC, Las Vegas, Nevada - (725) 444-8200 support@launchmaniac.com

import { useAuthStore } from '../stores/auth';

const authStore = useAuthStore();
</script>

<template>
  <header class="bg-white border-b border-gray-200 px-6 py-4">
    <div class="flex items-center justify-between">
      <div class="flex items-center space-x-4">
        <div class="flex items-center space-x-2">
          <span class="text-sm text-gray-500">Location:</span>
          <span class="font-medium">{{ authStore.locationId || 'Not connected' }}</span>
        </div>
      </div>

      <div class="flex items-center space-x-4">
        <!-- Health indicators -->
        <div class="flex items-center space-x-3">
          <div class="flex items-center space-x-1">
            <span class="w-2 h-2 rounded-full bg-green-500" />
            <span class="text-xs text-gray-500">Provider</span>
          </div>
          <div class="flex items-center space-x-1">
            <span class="w-2 h-2 rounded-full bg-green-500" />
            <span class="text-xs text-gray-500">Worker</span>
          </div>
        </div>

        <!-- User info -->
        <div class="text-sm text-gray-600">
          {{ authStore.userName || 'Guest' }}
        </div>
      </div>
    </div>
  </header>
</template>
